<template>
  <div class="registration-page">
    <div class="registration-page-container">
      <div class="section">
        <div class="section-header">
          <h2>
            <span v-if="openMarketInfo.shndHphnYn === 'Y'">중고폰&nbsp;</span>
            <span v-if="openMarketInfo.rsvSaleYn === 'Y'">예약판매&nbsp;</span>
            <!--[ST] [오픈마켓유심가입]2025.12.18 전승미 -->
            <span v-if="openMarketInfo.usimEntrAppfYn === 'Y'">USIM&nbsp;</span>
            <!--[ED] [오픈마켓유심가입]2025.12.18 전승미 -->
            서비스가입신청
          </h2>
          <span class="dynamic-data-temp info-tag">{{
            openMarketInfo.registrationTypeName
          }}</span>
        </div>
        <div class="section-body">
          <ul class="notice-text-list">
            <li class="notice-text">
              아래의 가입하신 정보는 회원님들의 동의 없이 공개되지 않으며,
              개인정보보호 정책에 의해 보호 받습니다.<br />
              LG유플러스 회원님의 개인정보보호를 위해 최선을 다할것을
              약속드립니다.
            </li>
          </ul>
        </div>
      </div>

      <div class="type-02 accordion" id="step2-part1">
        <div class="accordion-title active" id="" role="heading">
          <h3 tabindex="0">1단계: 가입자 기본정보 입력/선택</h3>
          <button
                  class="fold-button"
                  title="자세히보기"
                  tabindex="0"
                  area-controls="step2-part1-detail"
                  id="step2-part1-toggle"
                  ref="ref_cautionCheckedStatus"
          ></button>
        </div>

        <div
                class="accordion-detail"
                id="step2-part1-detail"
                aria-labelledby="step2-part1-toggle"
                role="region"
                v-show="$store.state.step2Accordion.isStep1"
        >
          <div class="sub-section mt0">
            <div class="input-container">
              <input
                      id="registration-caution-check"
                      type="checkbox"
                      v-model="cautionCheckedStatus"
                      name="caution"
                      value="caution"
                      class="input-checkbox input-text"
                      title="필수확인사항 체크"
              />
              <label for="registration-caution-check" class="input-label"
              ><em class="primary-text">(필수)</em> 대출업자 등 제3자에게
                고객명의의 휴대폰을 개통해 주거나, 개통에 필요한 신청서류를
                제공하는 경우 휴대폰 대출사기 등에 악용되어 심각한 경제적 피해를
                입을 수 있습니다.</label
              >
            </div>
          </div>
          <div v-if="openMarketInfo.dealCd !== ''">
            <Part1
                    :openMarketInfoProps="openMarketInfo"
                    :entrRsvTruthInfoProps="entrRsvTruthInfo"
                    :lawcAgntEntrRsvTruthInfoProps="lawcAgntEntrRsvTruthInfo"
                    :openMarketAgrInfoProps="openMarketAgrInfo"
                    :registrationProps="registration"
                    ref="part1Section"
            />
          </div>
          <div class="step-bottom-area input-wrap">
            <button class="normal-button mw30" @click="backToPreviousStep">
              이전
            </button>
            <button
                    v-if="hasApplicationNumber"
                    class="normal-button mw30"
                    @click="deleteRegistration"
            >
              삭제
            </button>
            <button
                    class="primary-button mw100 pc-float-right"
                    @click="save('step1')"
            >
              저장 후 다음으로 이동
            </button>
          </div>
        </div>
      </div>
      <!--accordion1 ends-->

      <div class="type-02 accordion">
        <div class="accordion-title" id="" role="heading">
          <h3 tabindex="0">2단계: 가입자 서비스 입력/선택</h3>
          <button
                  class="fold-button"
                  title="자세히보기"
                  tabindex="0"
                  area-controls="step2-part2-detail"
                  id="step2-part2-toggle"
                  ref="step2Toggle"
          ></button>
        </div>

        <div
                class="accordion-detail"
                id="step2-part2-detail"
                aria-labelledby="step2-part2-toggle"
                role="region"
                v-show="$store.state.step2Accordion.isStep2"
        >
          <!-- Part2 -->
          <div v-if="openMarketInfo.dealCd !== ''">
            <Part2
                    :openMarketInfoProps="openMarketInfo"
                    :registrationProps="registration"
                    :sectionDataProps="part2"
                    ref="part2Section"
            />
          </div>

          <div class="step-bottom-area input-wrap">
            <button class="normal-button mw30" @click="backToPreviousPart">
              이전
            </button>
            <button
                    v-if="hasApplicationNumber"
                    class="normal-button mw30"
                    @click="deleteRegistration"
            >
              삭제
            </button>
            <button
                    class="primary-button mw100 pc-float-right"
                    @click="save('step2')"
            >
              저장 후 다음으로 이동
            </button>
          </div>
        </div>
      </div>
      <!--accordion2 ends-->
    </div>
    <v-dialog />
  </div>
</template>

<script>
  import { watchRefreshKeyPress } from '@/system/common'
  import Part1 from './Part1'
  import Part2 from './Part2'
  import { getComCodeList } from '@/api/metaService'
  import {
    getRegistration,
    getRegistrationInit,
    deleteRegistration,
    createRegistration
  } from '@/api/captureService'
  import { getOpenMarketInfo } from '@/api/openmarket'
  import { actionType } from '@/store'
  import { router } from '@/router/router'

  export default {
    name: 'RegistrationStep2',

    components: {
      Part2,
      Part1
    },

    props: {},

    data() {
      return {
        openMarketInfo: {
          dealNm: '',
          agentId: '',
          agentName: '',
          agentAddress: '',
          agentTelNo: '',
          sellerName: '',
          sellerAddress: '',
          sellerTelNo: '',
          sellerRegistrationNo: '',
          sbgnPosCd: '',
          sbgnPosNm: '',
          openMarketCode: '', //오픈마켓번호
          openMarketName: '',
          msBsType: '', //기업부문 BS
          entrRqstFomNo: '', //양식ID
          dealCd: '', //대리점코드
          opmkEntrKdCd: '', //가입유형코드
          isttYn: '', //할부여부
          isttAmt: '', //할부금액
          registrationTypeCode: '', //가입유형
          registrationTypeName: '', //가입유형명
          rotrRqstCd: '',
          shndHphnYn: '', //중고여부
          rcmdSaleKcCd: '', //추천판매 agmtTermMmct discGb
          mblSvcDivsCd: '', //G106M2MLZP0002200모바일서비스구분코드
          dataPpMndtYn: '', //데이터요금제 필수여부
          dlrGroup: '',
          resCode: '',
          resMsg: '',
          onetDealOrgDivsCd: '',
          appfTitNm: '',
          appfDutyAgmtAmt: '',
          crgrSaleYn: '',
          rqstCustDelKdCd: '',
          rqstOrdrNoTitNm: '',
          rqstTmpDutyAgmtAmt: '',
          onetRcmdSaleCd: '',
          appfUseStrtDttm: '',
          appfUseEndDttm: '',
          ppfUseYn: '',
          rqstBdlProdCd: '',
          rsvSaleNm: '',
          dcntKdNm: '',
          chocAgmtMmct: '',
          addSuptAmtUseYn: '',
          rotrRqstYn: '',
          svcDivsCd: '',
          rsvSaleYn: '',
          miltaryAgentYn: '',
          emalAddr: '',
          faxNo: '',
          chocAgmtDcntUseYn: ''   // 할인유형명
          // [단통법폐지Prj] Start 단통법 폐지관련 해당 항목 삭제 됨. 2025.06.04 miyoung34
          ,lrpsDiscOpenYn : 'N'   // 단통법폐지 프로젝트 오픈여부
          ,presaleTrmMdlCdYn:'N'    // 단통법폐지 프로젝트 오픈 전 사전예약판매단말여부
          ,presaleTrmMdlCdTxt : '' // 단통법폐지 프로젝트 오픈 전 사전예약판매단말ID(여러건인경우,구분자)
          ,dmbrYn:'N'               //직영점여부
          // [단통법폐지Prj] End 단통법 폐지관련 해당 항목 삭제 됨. 2025.06.04 miyoung34
          // [ST] [오픈마켓유심가임] 2025.12.18 전승미
          ,usimEntrAppfYn : ''     //USIM가입신청서여부
          // [ED] [오픈마켓유심가입] 2025.12.18 전승미
        },
        registration: {
          dcntKdNm: '', // 할인유형명
          pymnBday: '', // 납부자생년월일
          appfNo: '', //신청서번호
          crypAppfNo: '', // 암호화 신청서번호
          rqstPgrsStusNm: '', //신청진행상태명
          onetKdCd: '', //가입유형코드
          onetKdNm: '', //가입유형명
          ppCd: '', //요금제코드
          sppsProdCdCntn: '', //부가서비스상품코드내용
          dataPpCd: '', //데이터요금제코드
          custKdCd: '', //고객유형코드
          aplcNm: '', //신청자명
          aplcDerno: '', //신청자주민등록번호--------------->최초
          aplcDernoMask: '', //신청자주민등록번호--------------->마스킹
          aplcErrno: '', //암호화 주민번호 20240527
          aplcTlno: '', //신청자전화번호
          aplcEmalAddr: '', //신청자이메일주소
          bltxRcepMthdCd: '', //청구서수령방법코드
          billDivsCd: '', //청구구분코드
          crplZpcd: '', //청구지우편번호
          crplAddr: '', //청구지주소
          crplDadr: '', //청구지상세주소
          pymnDivsCd: '', //납부자구분코드 TODO 본인:1 / 타인:2
          pymnNm: '', //납부자명 TODO 청소년이면 대리인
          pymnDerno: '', //납부자주민등록번호--------------->최초 TODO 청소년이면 대리인
          pymnEmalAddr: '', //납부자이메일주소 TODO 청소년이면 대리인
          paymMthdDivsCd: '', //납부방법구분코드
          bankNm: '', //은행명
          CdcoNm: '', //카드사명
          onetBankCd: '', //온라인가입은행코드
          onetCdcoCd: '', //온라인가입카드사코드
          acctCardNo: '', //계좌카드번호--------------->화면보기
          acctCardNoMask: '', //계좌카드번호마스킹
          ccrdValdTermEndYymm: '', //신용카드유효기간종료년월
          wdrwAgrYn: '', //출금동의여부
          mnpSoacTrgtCd: '', //번호이동정산대상코드
          mnpSoacNo: '', //번호이동정산번호
          noRnftEnprCd: '', //번호이동전사업자코드
          trmSrno: '', //단말시리얼번호
          dvicMdlCd: '', //단말기모델코드
          dvicMdlNm: '', //단말기모델명
          dvicColrCd: '', //단말기색상코드
          hphnColrNm: '', //휴대폰색상명
          chgHopTlno: '', //변경희망전화번호
          crgrBuyYn: '', //충전기구매여부
          ppNm: '', //요금제명
          dataPpNm: '', //데이터요금제명
          sppsProdNmCntn: '', //부가서비스상품명내용
          adltCntsIsolRqstYn: '', //성인컨텐츠차단신청여부
          agntEntrRstnYn: '', //대리인가입제한여부
          lawcAgntNm: '', //법정대리인명
          decLawcAgntCrypRrno: '', //------->입력
          lawcAgntCrypRrno: '', // 20240527 법정대리인암호화주민번호
          lawcAgntCrypRrnoMask: '', //법정대리인암호화주민등록번호마스킹
          lawcAgntTlno: '', //법정대리인전화번호
          lawcAgntZpcd: '', //법정대리인우편번호
          lawcAgntAddr: '', //법정대리인주소
          lawcAgntDadr: '', //법정대리인상세주소
          isttTermMmct: '', //할부기간개월수 halbuMonth
          tinsAmt: '0', //총할부금액 halbuPrice
          adseRqstDivsCd: '', //선결제신청구분코드
          lssInsrDivsNm: '', //분실보험구분명
          lssDsydCmpsEntrAgrCntn: '', //분실파손보상가입동의내용
          dcntDivsCd: '', //할인구분코드
          dcntTermMmct: '', //할인기간개월수 =agreedMonthM2M / discMonth
          dcntKdCd: '', //할인유형코드
          agmtTermMmct: '', //약정기간개월수
          onsaAplyPlnNm: '', //온라인가입지원적용플랜명
          iphnUseAgrYn: '', //아이폰사용동의여부
          nwIsolYn: '', //네트워크차단여부
          entrAppfDvrMthdCd: '', //가입신청서교부방법코드
          entrAppfDvrMthdNm: '', //가입신청서교부방법명
          dlvRcipNm: '', //배송수령자명
          dlplZpcd: '', //배송지우편번호
          dlplBadr: '', //배송지기본주소
          dlplDadr: '', //배송지상세주소
          dlplTlno: '', //배송지전화번호
          dlvCtplNm: '', //배송연락처명
          custInfoGthrAgrYn: '', //고객정보수집동의여부
          pnifPuseTrstAgrYn: '', //개인정보활용위탁동의여부
          locFndnInfoOfrSvcAgrYn: '', //위치기반정보제공서비스동의여부
          autnMthdDivsCd: '', //인증방법구분코드
          prmsLinePcnt: '', //허용회선개수
          addReqMttrCntn: '', //추가요청사항내용
          dutyAgmtSuptAmt: '', //의무약정지원금액 =dutyAgmtSuptAmt
          hphnInitStlmAmt: '0', //휴대폰초기결제금액
          lssInsrCnslAgrYn: '', //분실보험상담동의여부
          dutyAgmtAgrYn: 'N', //의무약정동의여부 agreedAgreeYn
          rqstSppsCdCntn: '', //신청부가서비스코드내용
          dealAgmtAmt: '', //대리점약정금액
          custBday: '', //고객생년월일
          lawcAgntAgrYn: '', //법정대리인동의여부
          smatAppUseYn: '', //스마트APP사용여부
          bukeAppUseYn: '', //사업지키미APP사용여부f
          rotrRqstYn: '', //라우터신청여부 formRoutrYn
          rotrAgmtMmct: '', //라우터약정개월수
          rotrAgmtAmt: '', //라우터약정금액
          browDivsCd: '', //브라우저구분코드
          rqstSppsNmCntn: '', //신청부가서비스명내용
          entrRqstFomNo: '', //가입신청양식번호
          opmkNo: '', //오픈마켓번호
          onlnAppfNo: '', //온라인신청서번호
          sbgnPosCd: '', //개통POS코드
          sbgnDealCd: '', //개통대리점코드
          dealNm: '', //대리점명
          opmkNm: '', //오픈마켓명
          svcDivsCd: '', //서비스구분코드
          shpnEntrRqstYn: '', //중고폰가입신청여부
          onetAplePncrDivsCd: '', // 내 맘대로 폰교체
          //[단통법폐지Prj] Start 단통법 폐지관련 추가 2025.06.04 miyoung34
          onsaWlcmAplyDivsCd:	'-',// 온라인가입지원우대적용구분코드
          dbnwSuptAmt: 0,		// 유통망지원금
          //[단통법폐지Prj] End 단통법 폐지관련 추가 2025.06.04 miyoung34
          //[ST] [오픈마켓유심가입] 2025.12.18 전승미
          trmStusDivsCd : '', //단말상태구분코드
          //[ED] [오픈마켓유심가입] 2025.12.18 전승미
          mobileRegistrationCaptureDetail:{
            appfNo:'',
            onetAutnDivsCd:'',//인증방법상세
            g5CovrWideCtdoNm: '', //5G 시도
            g5CovrCcwNm: '', //5G 시군구
            g5CovrTownNm: '' //5G 읍면동
            //[ST]신규부가서비스(디즈니)반영요청건 2021.11.15 박지숙
            ,onetDsnySppsAgrYn:''
            //[ED]신규부가서비스(디즈니)반영요청건 2021.11.15 박지숙
            ,usimRqstYn:'' // USIM 신청 여부
            ,esimTrmYn:'' // eSIM 단말기 여부
            ,mnpCvrtSuptAmt:'' //전환지원금
            ,addCvrtSuptAmt:'' //추가전환지원금
            ,onsaPrevPpUseYn:'' //온라인가입지원변경전요금제사용여부 
            ,onsaPrevPpCd:'' //온라인가입지원변경전요금제코드 
            ,onsaPrevPpNm:'' //온라인가입지원변경전요금제명
            //,openMarketAgrList:[] // privacy센터 연동 동의정보 리스트
            //[ST] RITM2876892 M2M 요금약정기간 추가 건
            ,m2mPpAgdcMmct:''
            ,m2mPpAgdcTermNm:''
            ,agdcRfunAgrYn:''
            //[ED] RITM2876892 M2M 요금약정기간 추가 건
          }
        },
        entrRsvTruthInfo: {
          onetMblAppfNo: '',
          onetIdcdDivsCd: '', //G116
          onetIndvDivsCd: '', //G117
          onetDivsCd: '', //G129
          agrYn: '',
          lawcAgntAgrYn: '',
          custNm: '',
          isuDt: '',
          drvLcnsNo: '', //초기입력
          drvLcnsNoMask: '', //화면
          crypDrvLcnsNo: '', //DB
          drvLcnsIsuAreaCd: '',
          bday: '',
          lawcAgntNm: '',
          coBrno: '',
          conmNm: '',
          monmCsntNo: ''
        },
        lawcAgntEntrRsvTruthInfo: {
          onetMblAppfNo: '',
          onetIdcdDivsCd: '', //G116
          onetIndvDivsCd: '', //G117
          onetDivsCd: '', //G129
          agrYn: '',
          lawcAgntAgrYn: '',
          custNm: '',
          isuDt: '',
          drvLcnsNo: '', //초기입력
          drvLcnsNoMask: '', //화면
          crypDrvLcnsNo: '', //DB
          drvLcnsIsuAreaCd: '',
          bday: '',
          lawcAgntNm: '',
          coBrno: '',
          conmNm: '',
          monmCsntNo: ''
        },
        openMarketAgrInfo: [], //privacy 동의정보
                 
        // part2에 필요한 데이터
        part2: {
          formM2MYn: 'N', //M2M 여부

          /* 단통법 정보 */
          dlvrPrc: '0', //출고가
          suprtAmt24: '0', //이통사 공시 지원금
          suprtAmt12: '0', //이통사 공시 지원금
          totalSuprtAmt: '0', //총지원금
          addSuprtAmt24: '0', //추가지원금
          addSuprtAmt12: '0', //추가지원금
          mnpCvrtSuptAmt: '0', //전환지원금 
          addCvrtSuptAmt: '0', //추가전환지원금

          checkedRqstSppsCdList: [], // 선택된 부가서비스

          agreedYn: false, // 라우터 데이터 여부
          agreedMonthDataSize: 0,
          formRoutrAgrMonthDataSize: 0,
          agreedMonthDataM2MSize: 0
        },

        cautionCheckedStatus: false,
        hasApplicationNumber: false,

        comCode: {
          emailDomainList: [],
          dataFeeList: [],
          validationMethodList: [],
          driverRegionList: [],
          bankList: [],
          cardList: []
        },
        isShow: false,
        validate: false
      }
    },

    computed: {},

    beforeMount() {

    },
    created() {
      watchRefreshKeyPress()
    },

    mounted() {
      this.initPage()
      this.$store.state.step2Accordion.isStep1 = true
      this.$store.state.step2Accordion.isStep2 = false

      this.$store.state.processIndicator.step1 = false
      this.$store.state.processIndicator.step2 = true
      this.$store.state.processIndicator.step3 = false
      this.$store.state.processIndicator.step4 = false
    },

    methods: {
      /**
       * Function    : initPage
       * Description : 초기 페이지 진입시 이메일로 접근하면, 신청서 정보와 양식 정보 가져오기
       **/
      initPage() {
        let applicationNumber = this.$store.state.applicationNumber
        this.hasApplicationNumber = false
        if (applicationNumber !== '') {
          getRegistrationInit(applicationNumber).then(res => {
            this.registration = _.cloneDeep(res.data.opmktRegistrationCapture)   
            let retCrypAppfNo = res.data.opmktRegistrationCapture.crypAppfNo
            if(applicationNumber !== retCrypAppfNo){
                    this.openAlert(
                      '온라인 가입신청 안내',
                      '조회정보가 올바르지 않습니다.\n다시 접속후 신청서를 작성하여 주시기 바랍니다.'
              )
              return
            }
            if (
                    this.registration.rqstPgrsStusCd === '40' ||
                    this.registration.rqstPgrsStusCd === '30' ||
                    (this.registration.rqstPgrsStusCd === '20' && this.registration.cnslPgrsStusCd !== '00')
            ) {
              this.$router.push({
                name: 'RegistrationStep4'
              })
            }
            if(this.registration.rqstPgrsStusCd === '10') {
              this.hasApplicationNumber = true
            }
            this.$store.state.step1.customer.custKdCd = this.registration.custKdCd
            if(!this.registration.sbgnDealCd|| !this.registration.entrRqstFomNo || !this.registration.opmkNo) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '정보가 조회되지않았습니다.\n다시 접속후 신청서를 작성하여 주시기 바랍니다.'
              )
              return
            }
            this.$store.state.step1.customer.name = this.registration.aplcNm
            this.$store.state.step1.customer.ssn1 = this.registration.custBday
            this.getOpenMarketInfo(
                    this.registration.sbgnDealCd,
                    this.registration.entrRqstFomNo,
                    this.registration.opmkNo,
                    'saved'
            ) // openmarketInfo 저장

            if (res.data.entrRsvTruthInfo !== null) {
              this.entrRsvTruthInfo = _.cloneDeep(res.data.entrRsvTruthInfo)
            }

            if (res.data.lawcAgntEntrRsvTruthInfo !== null) {
              this.lawcAgntEntrRsvTruthInfo = _.cloneDeep(
                      res.data.lawcAgntEntrRsvTruthInfo
              )
            }
          })
        } else {
          if(!this.$store.state.openMarketInfo.dealCd|| !this.$store.state.openMarketInfo.formId || !this.$store.state.openMarketInfo.openMarketCode) {
            this.openAlert(
                    '온라인 가입신청 안내',
                    '정보가 조회되지않았습니다.\n다시 접속후 신청서를 작성하여 주시기 바랍니다.'
            )
            return
          }
          this.getOpenMarketInfo(
                  this.$store.state.openMarketInfo.dealCd,
                  this.$store.state.openMarketInfo.formId,
                  this.$store.state.openMarketInfo.openMarketCode,
                  'new'
          ) // openmarketInfo 저장
        }
      },

      /**
       * Function    : getOpenMarketInfo
       * Description : 오픈마켓 정보 호출
       **/
      getOpenMarketInfo(sbgnDealCd, entrRqstFomNo, opmkNo, type) {
        if(!sbgnDealCd|| !entrRqstFomNo || !opmkNo) {
          this.openAlert(
                  '온라인 가입신청 안내',
                  '정보가 조회되지않았습니다.\n다시 접속후 신청서를 작성하여 주시기 바랍니다.'
          )
          return
        }
        getOpenMarketInfo(sbgnDealCd, entrRqstFomNo, opmkNo).then(res => {
          this.openMarketInfo = res.data
          this.openMarketInfo.agentId = sbgnDealCd
          this.openMarketInfo.dealCd = sbgnDealCd
          this.openMarketInfo.formId = entrRqstFomNo
          this.openMarketInfo.entrRqstFomNo = entrRqstFomNo
          this.openMarketInfo.openMarketCode = opmkNo

          //[단통법폐지Prj] Start 단통법 폐지관련 추가 2025.06.04 miyoung34
          this.$store.state.openMarketInfo.lrpsDiscOpenYn     = this.openMarketInfo.lrpsDiscOpenYn;
          this.$store.state.openMarketInfo.presaleTrmMdlCdTxt = this.openMarketInfo.presaleTrmMdlCdTxt;
          this.$store.state.openMarketInfo.dmbrYn             = this.openMarketInfo.dmbrYn;               // 직영점여부
          this.$store.state.openMarketInfo.dbnwSufuAcacgCd    = this.openMarketInfo.dbnwSufuAcacgCd;      // 획득비분석채널그룹코드
          //[단통법폐지Prj] End 단통법 폐지관련 추가. 2025.06.04 miyoung34

          if (!this.openMarketInfo.entrRqstFomNo) {
            router.replace({
              name: 'Error',
              props: true,
              params: {
                message:
                        '현재 접근 하신 경로는 올바르지 않은 접속 경로 입니다.\n올바른 경로를 통하여 다시 접속하여 주세요.',
                type: 'access'
              }
            })
          }

          if (this.openMarketInfo.mblSvcDivsCd === 'LZP0002200') {
            this.part2.formM2MYn = 'Y' //ASIS agreedYn : 'none'
          } else {
            this.part2.formM2MYn = 'N' //ASIS agreedYn : ''
          }
          if (type === 'saved') {
            this.setPart1Data()
            this.setPart2Data()
          }
        })
      },

      /**
       * Function    : setPart1Data
       * Description : part1 초기값 세팅 (이메일 아이디/ 도메인)
       **/
      setPart1Data() {
        this.$store.state.step1.customer.emailId = (
                this.registration.aplcEmalAddr || ''
        ).split('@')[0]
        this.$store.state.step1.customer.emailDomain = (
                this.registration.aplcEmalAddr || ''
        ).split('@')[1]
      },

      /**
       * Function    : setPart2Data
       * Description : part2 초기값 세팅 (선택옵션 부가서비스)
       **/
      setPart2Data() {
        // 선택된 옵션부가서비스
        this.part2.checkedRqstSppsCdList =
                this.registration.rqstSppsCdCntn === null
                        ? []
                        : this.registration.rqstSppsCdCntn.split(',')
      },

      /**
       * Function    : getPart2
       * Description : Part2 데이터 가져오는 함수
       **/
      getPart2() {
        this.$refs.part2.getData()
      },

      /**
       * Function    : backToPreviousStep
       * Description : 이전 Step으로 이동
       **/
      backToPreviousStep() {
        this.$router.go(-1)
      },

      /**
       * Function    : saveAndContinueToStep3
       * Description : 저장 후 Step3로 이동
       **/
      saveAndContinueToStep3() {
        this.$router.push({
          name: 'RegistrationStep3',
          params: {
            registration: this.registration,
            openMarketInfo: this.openMarketInfo,
            entrRsvTruthInfo: this.entrRsvTruthInfo,
            openMarketAgrInfo: this.openMarketAgrInfo, //privacy 추가
            lawcAgntEntrRsvTruthInfo: this.lawcAgntEntrRsvTruthInfo
          }
        })
      },

      /**
       * Function    : deleteRegistration
       * Description : 신청서 삭제
       **/
      deleteRegistration() {
        let title = '온라인 가입신청 안내'
        this.$modal.show('dialog', {
          title: '<h1>온라인 가입신청 안내</h1>',
          text: '신청서를 삭제하시겠습니까?',
          buttons: [
            {
              title: '취소'
            },
            {
              title: '확인',
              class: 'primary-button',
              handler: () => {
                this.$modal.hide('dialog')
                deleteRegistration(this.registration.appfNo).then(
                        res => {
                          this.$modal.show('dialog', {
                            title: '<h1>온라인 가입신청 안내</h1>',
                            text: '정상적으로 삭제되었습니다.',
                            buttons: [
                              {
                                title: '확인',
                                class: 'primary-button',
                                handler: () => {
                                  this.$router.push({
                                    name: 'OpenMarket',
                                    query: {
                                      formId: this.openMarketInfo.entrRqstFomNo,
                                      agentId: this.openMarketInfo.dealCd,
                                      openmktCd: this.openMarketInfo.openMarketCode
                                    }
                                  })
                                }
                              }
                            ]
                          })
                        }
                )
              }
            }
          ]
        })
      },

      /**
       * Function    : openAlert
       * Description : 기본 alert 호출 함수
       **/
      openAlert(title, message, ref) {
        this.$modal.show('dialog', {
          title: title,
          text: message,
          buttons: [
            {
              title: '확인',
              class: 'primary-button',
              handler: () => {
                this.$modal.hide('dialog')
                if (ref) {
                  ref.focus()
                }
              }
            }
          ]
        })
      },

      /**
       * Function    : saveAndContinueStep2
       * Description : 저장 후 Part2로 이동
       **/
      saveAndContinueStep2() {
        this.showHideAccordion1()
        this.showHideAccordion2()
        // this.$refs.step2Toggle.focus()
        window.scrollTo(0, 0)
      },

      /**
       * Function    : save
       * Description : 데이터 저장 함수
       **/
      save(type) {
        if (type === 'step2') {
              this.registration.mobileRegistrationCaptureDetail.appfNo = this.registration.appfNo;
              
            this.openMarketAgrInfo = _.cloneDeep(this.$store.state.step1.openMarketAgrInfo) //privacy센터 추가
            //console.log("initPage this.openMarketAgrInfo step2:", this.openMarketAgrInfo);
        }

        let stepParam = '1'
        if (type === 'step1') {
          if (!this.validateStep2Part1()) return
          stepParam = '1'
          let part1Data = this.$refs.part1Section.savePart1()
          this.registration = part1Data.registration
          this.entrRsvTruthInfo = part1Data.entrRsvTruthInfo
          this.lawcAgntEntrRsvTruthInfo = part1Data.lawcAgntEntrRsvTruthInfo
          this.openMarketAgrInfo = part1Data.openMarketAgrInfo //pricacy센터 추가
          this.$refs.part2Section.registration = part1Data.registration
        }
        if (type === 'step2') {
          if (!this.validateStep2Part2()) return
          stepParam = '2'
          this.registration = this.$refs.part2Section.savePart2()
          if(this.registration.dcntKdCd === 'DT01') {
            Object.assign(this.registration, {onsaAplyPlnNm:this.$refs.part2Section.onsaAplyPlnNm})
          } else {
            Object.assign(this.registration, {onsaAplyPlnNm:''})
          }
        }

        let title = '온라인 가입신청 안내'
        this.$modal.show('dialog', {
          title: '<h1>온라인 가입신청 안내</h1>',
          text: '신청서를 임시저장하시겠습니까?',
          buttons: [
            {
              title: '취소'
            },
            {
              title: '확인',
              class: 'primary-button',
              handler: () => {
                this.$modal.hide('dialog')
                if (type === 'step1') {
                  this.registration.custInfoGthrAgrYn = this.$store.state.step1.custInfoGthrAgrYn
                  this.registration.pnifPuseTrstAgrYn = this.$store.state.step1.pnifPuseTrstAgrYn
                  this.registration.locFndnInfoOfrSvcAgrYn = this.$store.state.step1.locFndnInfoOfrSvcAgrYn
                  this.registration.mblAdRcpAgrYn = this.$store.state.step1.mblAdRcpAgrYn
                  this.registration.svcDivsCd = this.openMarketInfo.mblSvcDivsCd
                  this.registration.rsvSaleNm = this.openMarketInfo.rsvSaleNm

                  this.registration.aplcNm = this.$store.state.step1.customer.name
                  //this.registration.aplcDerno =
                   //       this.$store.state.step1.customer.ssn1 +
                   //       this.$store.state.step1.customer.ssn2
                  this.registration.aplcErrno = this.$store.state.step1.customer.aplcErrno
                  this.registration.custKdCd = this.$store.state.step1.customer.custKdCd

                  this.registration.onetKdCd = this.openMarketInfo.registrationTypeCode //opmkEntrKdCd
                  this.registration.onetKdNm = this.openMarketInfo.registrationTypeName
                  this.registration.entrRqstFomNo = this.openMarketInfo.formId
                  this.registration.sbgnDealCd = this.openMarketInfo.dealCd
                  this.registration.opmkNo = this.openMarketInfo.openMarketCode
                  this.registration.dealNm = this.openMarketInfo.agentName
                  this.registration.opmkNm = this.openMarketInfo.openMarketName
                  this.registration.shpnEntrRqstYn =
                          this.openMarketInfo.shndHphnYn === 'Y' ? 'Y' : 'N'
                  
                  //[ST] [오픈마켓유심가입] 2025.12.18 전승미
                  if(this.openMarketInfo.shndHphnYn !== 'Y') {
                    this.registration.shpnEntrRqstYn =
                            this.openMarketInfo.usimEntrAppfYn === 'Y' ? 'Y' : 'N' //유심가입신청서이면 중고폰가입신청여부 Y  
                  }
                  this.registration.trmStusDivsCd =
                          this.openMarketInfo.usimEntrAppfYn === 'Y' ? '01' : '' //유심가입신청서이면 단말상태구분코드 01:중고/자급제  
                  //console.log("step1 this.openMarketInfo.shndHphnYn :", this.openMarketInfo.shndHphnYn)
                  //console.log("step1 this.openMarketInfo.usimEntrAppfYn :", this.openMarketInfo.usimEntrAppfYn)
                  //console.log("step1 this.registration.shpnEntrRqstYn :", this.registration.shpnEntrRqstYn)   
                  //console.log("step1 this.registration.trmStusDivsCd :", this.registration.trmStusDivsCd)        
                  //[ED] [오픈마켓유심가입] 2025.12.18 전승미

                  this.registration.pymnDivsCd =
                          this.registration.custKdCd !== 'A' ? '1' : '2' //납부자구분코드 TODO 본인:1 / 타인:2
                  this.registration.pymnNm =
                          this.registration.custKdCd !== 'A'
                                  ? this.registration.aplcNm
                                  : this.registration.lawcAgntNm //납부자명 TODO 청소년이면 대리인
                  //this.registration.pymnDerno =
                  //        this.registration.custKdCd !== 'A'
                  //                ? this.registration.aplcErrno
                  //                : this.registration.lawcAgntCrypRrno //납부자주민등록번호--------------->최초 TODO 청소년이면 대리인
                  this.registration.pymnEmalAddr =
                          this.registration.custKdCd !== 'A'
                                  ? this.registration.aplcEmalAddr
                                  : '' //납부자이메일주소 TODO 청소년이면 대리인

                  this.registration.rotrRqstYn =
                          this.openMarketInfo.rotrRqstCd === 'Y' ? 'Y' : 'N'

                  if (this.entrRsvTruthInfo !== null) {
                    this.entrRsvTruthInfo.custNm = this.$store.state.step1.customer.name
                    this.entrRsvTruthInfo.onetIndvDivsCd = '01'
                    this.entrRsvTruthInfo.onetDivsCd = this.openMarketInfo.registrationTypeCode
                    this.entrRsvTruthInfo.agrYn = 'Y'
                  }

                  if (this.lawcAgntEntrRsvTruthInfo !== null) {
                    this.lawcAgntEntrRsvTruthInfo.custNm = this.registration.lawcAgntNm
                    // this.entrRsvTruthInfo.lawcAgntAgrYn = 'Y'
                    this.entrRsvTruthInfo.lawcAgntNm = this.registration.lawcAgntNm
                    this.lawcAgntEntrRsvTruthInfo.onetIndvDivsCd = '03'
                    this.lawcAgntEntrRsvTruthInfo.onetDivsCd = this.openMarketInfo.registrationTypeCode
                    this.lawcAgntEntrRsvTruthInfo.agrYn = 'Y'
                  }                 
                }
                if (type === 'step2') {
                  
                  //[ST] [오픈마켓유심가입] 2025.12.18 전승미
                  if(this.openMarketInfo.isttYn === 'Y' && this.openMarketInfo.shndHphnYn !== 'Y' && this.openMarketInfo.usimEntrAppfYn !== 'Y') {
                  //[ED] [오픈마켓유심가입] 2025.12.18 전승미
                    if (this.registration.dcntKdCd === 'DT01') {
                      this.registration.agmtTermMmct = ''
                    }
                    if (this.registration.dcntKdCd === 'DT02') {
                      this.registration.agmtTermMmct = this.registration.isttTermMmct
                    }
                    this.registration.isttTermMmct = '24'
                  }
                  //[ST] [오픈마켓유심가입] 2025.12.18 전승미
                  if(this.openMarketInfo.isttYn === 'N' || this.openMarketInfo.shndHphnYn === 'Y' || this.openMarketInfo.usimEntrAppfYn === 'Y') {
                  //[ED] [오픈마켓유심가입] 2025.12.18 전승미
                    this.registration.dcntKdCd = ''
                    this.registration.isttTermMmct = ''
                    this.registration.dutyAgmtSuptAmt = ''
                   // this.registration.rotrAgmtMmct = ''
                    this.registration.tinsAmt = '0'
                    this.registration.hphnInitStlmAmt = '0'
                  }
                  //[ST] [오픈마켓유심가입] 2025.12.18 전승미
                  if(this.openMarketInfo.shndHphnYn === 'Y' || this.openMarketInfo.usimEntrAppfYn === 'Y') {
                  //[ED] [오픈마켓유심가입] 2025.12.18 전승미
                    this.registration.dutyAgmtSuptAmt = '0'
                    this.registration.dealAgmtAmt = '0'
                    this.registration.rotrAgmtAmt = '0'
                  }

                  if (this.registration.lssInsrCnslAgrYn === '1') {
                    this.registration.lssInsrDivsNm = '종합형(분실,파손보장)'
                  } else if (this.registration.lssInsrCnslAgrYn === '3') {
                    this.registration.lssInsrDivsNm = '파손형(파손만보장)'
                  } else if (this.registration.lssInsrCnslAgrYn === '2') {
                    this.registration.lssInsrDivsNm = '신청을 원하지 않음'
                  }
                  if(this.registration.onetAplePncrDivsCd == '00') {
                   // this.registration.lssDsydCmpsEntrAgrCntn = '맘대로 폰교체 미가입 '

                  } else if(this.registration.onetAplePncrDivsCd == '01') {

                  //  this.registration.lssDsydCmpsEntrAgrCntn = '맘대로 폰교체 교체형가입'

                  }
                }

                createRegistration(
                        this.registration,
                        this.entrRsvTruthInfo,
                        this.lawcAgntEntrRsvTruthInfo,
                        this.openMarketAgrInfo, //privacy센터 추가
                        stepParam
                ).then(res => {
                  let response = res.data.appfNo
                  let crypAppfNo = res.data.crypAppfNo
                  if (response !== '') {
                    this.$modal.show('dialog', {
                      title: '<h1>온라인 가입신청 안내</h1>',
                      text: '정상적으로 저장 되었습니다.',
                      buttons: [
                        {
                          title: '확인',
                          class: 'primary-button',
                          handler: () => {
                            this.$store.dispatch(
                                    actionType.saveApplicationNumber,
                                    crypAppfNo
                            )
                            this.registration.appfNo = response
                            this.registration.crypAppfNo = crypAppfNo
                            this.entrRsvTruthInfo.onetMblAppfNo = response
                            if (this.registration.custKdCd === 'A') {
                              this.lawcAgntEntrRsvTruthInfo.onetMblAppfNo = response
                            }
                            this.$modal.hide('dialog')
                            if (type === 'step1') {
                              this.$refs.part2Section.registration = this.registration
                              this.saveAndContinueStep2()
                            }
                            if (type === 'step2') {
                              this.saveAndContinueToStep3()
                            }
                          }
                        }
                      ]
                    })
                  } else {
                    this.openAlert(title, '저장도중 오류가 발생했습니다.')
                    return false
                  }
                })
              }
            }
          ]
        })
      },

      /**
       * Function    : showHideAccordion1
       * Description : Part1 Accordion 제어 함수
       **/
      showHideAccordion1() {
        const panel = document.getElementById('step2-part1-detail')
        if (this.$store.state.step2Accordion.isStep1) {
          this.$store.state.step2Accordion.isStep1 = false
          panel.previousElementSibling.classList.toggle('active')
        } else {
          this.$store.state.step2Accordion.isStep1 = true
          panel.previousElementSibling.classList.toggle('active')
        }
      },

      /**
       * Function    : showHideAccordion2
       * Description : Part2 Accordion 제어 함수
       **/
      showHideAccordion2() {
        const panel = document.getElementById('step2-part2-detail')
        if (this.$store.state.step2Accordion.isStep2) {
          this.$store.state.step2Accordion.isStep2 = false
          panel.previousElementSibling.classList.toggle('active')
        } else {
          this.$store.state.step2Accordion.isStep2 = true
          panel.previousElementSibling.classList.toggle('active')
        }
      },

      /**
       * Function    : validateStep2Part1
       * Description : Part1 필수값 Validation
       **/
      validateStep2Part1() {
        if (!this.cautionCheckedStatus) {
          this.openAlert(
                  '온라인 가입신청 안내',
                  '휴대폰 대출사기 피해예방 주의문구를 확인하세요.',
                  this.$refs.ref_cautionCheckedStatus
          )
          return false
        }
        if (!this.$refs.part1Section.validCondition()) {
          return false
        }
        return true
      },

      /**
       * Function    : validateStep2Part1
       * Description : Part2 필수값 Validation
       **/
      validateStep2Part2() {
        return this.$refs.part2Section.validCondition()
      },

      /**
       * Function    : backToPreviousPart
       * Description : 이전 파트로 이동
       **/
      backToPreviousPart() {
        this.showHideAccordion1()
        this.showHideAccordion2()
      }
    }
  }
</script>

<style scoped>
  .accordion-detail {
    visibility: visible;
    max-height: fit-content;
    max-height: none;
  }
</style>
